export enum ActionTypes {
  CREATE = 'CREATE',
  EDIT = 'EDIT',
  DELETE = 'DELETE',
  SELECT = 'SELECT',
  UNSELECT = 'UNSELECT',
  LOAD_COMPLETED = 'LOAD_COMPLETED',
  CREATE_COMPLETED = 'CREATE_COMPLETED',
  EDIT_COMPLETED = 'EDIT_COMPLETED',
  DELETE_COMPLETED = 'DELETE_COMPLETED',
}
